import axios from "axios";
import { BASE_API_URL } from "../constants/dropdown";

// Action Types
export const GET_POS_REQUESTS_REQUEST = "GET_POS_REQUESTS_REQUEST";
export const GET_POS_REQUESTS_SUCCESS = "GET_POS_REQUESTS_SUCCESS";
export const GET_POS_REQUESTS_FAIL = "GET_POS_REQUESTS_FAIL";

export const RETRIEVE_TERMINAL_REQUEST = "RETRIEVE_TERMINAL_REQUEST";
export const RETRIEVE_TERMINAL_SUCCESS = "RETRIEVE_TERMINAL_SUCCESS";
export const RETRIEVE_TERMINAL_FAIL = "RETRIEVE_TERMINAL_FAIL";
export const RETRIEVE_TERMINAL_RESET = "RETRIEVE_TERMINAL_RESET";

export const GET_TERMINAL_SYNC_STATUS_REQUEST = "GET_TERMINAL_SYNC_STATUS_REQUEST";
export const GET_TERMINAL_SYNC_STATUS_SUCCESS = "GET_TERMINAL_SYNC_STATUS_SUCCESS";
export const GET_TERMINAL_SYNC_STATUS_FAIL = "GET_TERMINAL_SYNC_STATUS_FAIL";
export const GET_TERMINAL_SYNC_STATUS_RESET = "GET_TERMINAL_SYNC_STATUS_RESET";

export const GET_SYNC_DRIFT_REQUEST = "GET_SYNC_DRIFT_REQUEST";
export const GET_SYNC_DRIFT_SUCCESS = "GET_SYNC_DRIFT_SUCCESS";
export const GET_SYNC_DRIFT_FAIL = "GET_SYNC_DRIFT_FAIL";

export const UPDATE_POS_CHARGES_REQUEST = "UPDATE_POS_CHARGES_REQUEST";
export const UPDATE_POS_CHARGES_SUCCESS = "UPDATE_POS_CHARGES_SUCCESS";
export const UPDATE_POS_CHARGES_FAIL = "UPDATE_POS_CHARGES_FAIL";
export const UPDATE_POS_CHARGES_RESET = "UPDATE_POS_CHARGES_RESET";

export const APPROVE_POS_REQUEST_REQUEST = "APPROVE_POS_REQUEST_REQUEST";
export const APPROVE_POS_REQUEST_SUCCESS = "APPROVE_POS_REQUEST_SUCCESS";
export const APPROVE_POS_REQUEST_FAIL = "APPROVE_POS_REQUEST_FAIL";
export const APPROVE_POS_REQUEST_RESET = "APPROVE_POS_REQUEST_RESET";

const getConfig = (getState) => {
  const {
    admin2faLogin: { userInfo },
  } = getState();
  const token = userInfo?.token?.access_token;
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
};

const buildQuery = (params) => {
  const valid = Object.entries(params).filter(
    ([_, v]) => v !== "" && v !== null && v !== undefined,
  );
  if (valid.length === 0) return "";
  return "?" + valid.map(([k, v]) => `${k}=${v}`).join("&");
};

export const fetchPosRequests =
  (page = 1, pageSize = 50, fromDate = "", toDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_POS_REQUESTS_REQUEST });
      const config = getConfig(getState);
      const query = buildQuery({ page, pageSize, from_date: fromDate, to_date: toDate });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/terminal/requests${query}`,
        config,
      );
      dispatch({ type: GET_POS_REQUESTS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_POS_REQUESTS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const retrieveTerminal =
  (terminalId, reason) => async (dispatch, getState) => {
    try {
      dispatch({ type: RETRIEVE_TERMINAL_REQUEST });
      const config = getConfig(getState);
      const { data } = await axios.post(
        `${BASE_API_URL}/admin/terminal/retrieve`,
        { terminal_id: terminalId, reason },
        config,
      );
      dispatch({ type: RETRIEVE_TERMINAL_SUCCESS, payload: data });
      return data;
    } catch (error) {
      const msg =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: RETRIEVE_TERMINAL_FAIL, payload: msg });
      throw new Error(msg);
    }
  };

export const fetchTerminalSyncStatus =
  (id, repair = false) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_TERMINAL_SYNC_STATUS_REQUEST });
      const config = getConfig(getState);
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/terminal/${id}/sync-status?repair=${repair}`,
        config,
      );
      dispatch({ type: GET_TERMINAL_SYNC_STATUS_SUCCESS, payload: data });
      return data;
    } catch (error) {
      const msg =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: GET_TERMINAL_SYNC_STATUS_FAIL, payload: msg });
      throw new Error(msg);
    }
  };

export const fetchSyncDrift = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_SYNC_DRIFT_REQUEST });
    const config = getConfig(getState);
    const { data } = await axios.get(
      `${BASE_API_URL}/admin/terminal/sync-drift`,
      config,
    );
    dispatch({ type: GET_SYNC_DRIFT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_SYNC_DRIFT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updatePosCharges = (id, body) => async (dispatch, getState) => {
  try {
    dispatch({ type: UPDATE_POS_CHARGES_REQUEST });
    const config = getConfig(getState);
    const { data } = await axios.patch(
      `${BASE_API_URL}/admin/limit/pos-charges/${id}/update`,
      body,
      config,
    );
    dispatch({ type: UPDATE_POS_CHARGES_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const msg =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: UPDATE_POS_CHARGES_FAIL, payload: msg });
    throw new Error(msg);
  }
};

export const approvePosRequest =
  (terminalId, customerId, businessId, requestId) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: APPROVE_POS_REQUEST_REQUEST });
      const config = getConfig(getState);
      const { data } = await axios.post(
        `${BASE_API_URL}/admin/terminal/assign/new`,
        {
          terminal_id: terminalId,
          customer_id: customerId,
          business_id: businessId,
          customer_terminal_request_id: requestId,
          terminal_action: "assign",
        },
        config,
      );
      dispatch({ type: APPROVE_POS_REQUEST_SUCCESS, payload: data });
      return data;
    } catch (error) {
      const msg =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: APPROVE_POS_REQUEST_FAIL, payload: msg });
      throw new Error(msg);
    }
  };
